import React, {Component} from 'react'
import FilterStatus from './filters/FilterStatus'
import FilterDateCreate from './filters/FilterDateCreate'
import PropTypes from "prop-types"

class JobsFilters extends Component {

    render() {
        const {onChangeSelect, filters} = this.props

        return (
            <div className="jumbotron px-3 pb-0 pt-3 mb-3">
                <div className='d-flex align-content-center ListingJobFilter'>
                    <FilterStatus status={filters.status} onChangeSelect={onChangeSelect}/>
                    <FilterDateCreate onChangeSelect={onChangeSelect}/>
                </div>
            </div>
        )
    }

}

JobsFilters.propTypes = {
    filters: PropTypes.object.isRequired,
    onChangeSelect: PropTypes.func.isRequired
}

export default JobsFilters